export const withQueryParams = (
  url: string,
  queryDict: { [key: string]: any; [key: number]: any },
) => {
  const searchParams = new URLSearchParams(queryDict ?? {}).toString();
  return searchParams ? `${url}?${searchParams}` : url;
};
